module.exports = __webpack_public_path__ + "media/images/img-pb-optima+-acdd58d1f44fc4e5c7d3f155148b741c.png";